import React, { useCallback } from "react";
import styled from "styled-components";
import Photo from "../components/Photo";
import Story from "../components/Story";
import Heading from "../components/Heading";
import { postMessage } from "../utils/postmessage";
import editable from "../utils/editable";
import { useOverflowDetectorWithTolerance } from "../hooks/useOverflowDetectorWithTolerance";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 80vw;
  height: 90vw;
`;

const OuterContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 80vw;
  height: 80vw;
`;

const InnerContainer = styled.div`
  order: ${(props) => props.position || 0};
`;

const StyledStory = styled(Story)`
  order: ${(props) => props.position || 0};
  ${(props) => props.position && `text-align:center;text-align-last: center;`}
  ${(props) => props.children && `width:auto;`}
`;

const StyledPhoto = styled(Photo)`
  order: ${(props) => props.position || 0};
`;

const Address = ({ customQuestions, header, handleOverflow = () => null }) => {
  const { items } = customQuestions;

  const { ref } = useOverflowDetectorWithTolerance({
    onChange: useCallback(
      (overflow) => {
        handleOverflow(overflow);
      },
      [handleOverflow]
    )
  });

  items.sort((a, b) => (a.position > b.position ? 1 : -1));

  return (
    <Container ref={ref}>
      <OuterContainer>
        {items.map((question, index) => (
          <React.Fragment key={index}>
            {question?.type === "image" && (
              <StyledPhoto
                mb={2.5}
                imgObject={question?.answers?.items?.[0]?.image || null}
                loading={question?.answers?.items?.[0]?.image?.loading || null}
                ratio={question?.ratio}
                {...editable(question)}
                onClick={(recommendedWidthPercentage, recommendedHeightPercentage) =>
                  postMessage({
                    ...question,
                    recommendedWidthPercentage,
                    recommendedHeightPercentage
                  })
                }
              />
            )}
            {question?.type === "title" && (
              <InnerContainer key={question?.id} position={question?.position}>
                {header !== "h2" ? (
                  <Heading.H3 tac mb={2.5} {...editable(question)} onClick={() => postMessage(question)}>
                    {question?.answers?.items?.[0]?.text || question?.placeholder}
                  </Heading.H3>
                ) : (
                  <Heading.H2 tac {...editable(question)} onClick={() => postMessage(question)}>
                    {question?.answers?.items?.[0]?.text || question?.placeholder}
                  </Heading.H2>
                )}
              </InnerContainer>
            )}
            {question?.type === "subtitle" && (
              <InnerContainer key={question?.id} position={question?.position}>
                <Heading.H4 tac mb={2.5} {...editable(question)} onClick={() => postMessage(question)}>
                  {question?.answers?.items?.[0]?.text || question?.placeholder}
                </Heading.H4>
              </InnerContainer>
            )}
            {question?.type === "story" && (
              <StyledStory {...editable(question)} onClick={() => postMessage(question)} position={question?.position} tac>
                {question?.answers?.items?.[0]?.text}
              </StyledStory>
            )}
          </React.Fragment>
        ))}
      </OuterContainer>
    </Container>
  );
};

export default Address;
